import * as React from 'react'
import { useState, useEffect } from 'react'
import { graphql } from 'gatsby'
import { useForm } from 'react-hook-form'
import Modal from 'react-bootstrap/Modal'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Popover from 'react-bootstrap/Popover'
import { callHook, getOS } from '../utils/utils'
var validator = require('email-validator')
import { Test } from '../components/Test';

export const BusinessCardReader = ({ slice, index }) => {
  const { title } = slice.primary

  const fileInputRef = React.useRef(null)

  const imageForm = useForm({
    mode: 'onChange',
  })

  const modalForm = useForm({
    mode: 'onChange',
  })

  const crmForm = useForm({
    mode: 'onChange',
  })

  const [showEditor, setShowEditor] = useState(false)
  const [showEmailModal, setShowEmailModal] = useState(false)
  const [showEmailModalSuccess, setShowEmailModalSuccess] = useState(false)
  const [showCRMList, setShowCRMList] = useState(false)
  const [showCRMForm, setShowCRMForm] = useState(false)
  const [showFinalState, setShowFinalState] = useState(false)

  const [isLoading, setLoading] = useState(false)
  const [isModalLoading, setModalLoading] = useState(false)

  const [isError, setError] = useState(false)
  //const [errorMessage, setErrorMessage] = useState()

  const [selectedCRM, setSelectedCRM] = useState()

  const [selectedFiles, setSelectedFiles] = useState([])
  const [imgErrorMessage, setImgErrorMessage] = useState()
  const [parsedData, setParsedData] = useState()
  const [editableData, setEditableData] = useState(parsedData || {})
  const [note, setNote] = useState()

  const [os, setOS] = useState(null)
  const [isMobile, setIsMobile] = useState(false)

  const [piwikVisitorId, setPiwikVisitorId] = useState('unknown')

  useEffect(() => {
    if (typeof window !== 'undefined' && window._paq) {
      var _paq = window._paq || []
      _paq.push([
        function () {
          setPiwikVisitorId(this.getVisitorId())
        },
      ])
    }

    setOS(getOS())

    const checkIsMobile = () => {
      if (os === 'iOS' || os === 'Android' || window.innerWidth < 992) {
        setIsMobile(true)
      } else {
        setIsMobile(false)
      }
    }

    checkIsMobile()
  }, [])

  const acceptedFileTypes = [
    'png',
    'jpg',
    'jpeg',
    //'gif',
    //'bmp',
    //'tif',
    //'tiff',
    //'pdf',
    //'heic'
  ]

  const isFirst = index === 0

  if (typeof window !== 'undefined') {
    const pageUrl = window.location
    //console.log('pageUrl: ', pageUrl);
  }

  const scrollToElement = (id) => {
    const element = document.getElementById(id)
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      })
    }
  }

  const submitImage = async (data) => {
    const formData = new FormData()
    formData.append('file1', selectedFiles[0])
    formData.append('file2', selectedFiles[1])
    formData.append('route', 'img-upload')

    setLoading(true)
    scrollToElement('loading')
    try {
      const response = await fetch('https://n8n-do.yohn.io/webhook/bcr', {
        method: 'POST',
        body: formData,
        headers: {
          Accept: 'application/json',
        },
      })

      if (response.ok) {
        const responseData = await response.json()
        console.log('responseData: ', responseData)
        if (responseData.parsed_data) {
          setParsedData(responseData.parsed_data)
          setEditableData(responseData.parsed_data)
          setNote(new Date().toLocaleString())
          setError(false)
        } /*else if (responseData.error_limit_reached) {
          setErrorMessage("Sorry, the service is currently unavailable. Please try again later.")
          setError(true)
        }*/ else {
          setError(true)
        }
      } else {
        setError(true)
      }
    } catch (error) {
      setError(true)
    }
    setShowEditor(true)
    setLoading(false)

    //piwik
    dataLayer.push({
      event: 'trackEvent',
      eventCategory: 'Business Card Reader',
      eventAction: 'BC scanned',
    })
  }

  const sentToEmail = async (data) => {
    const url = 'https://n8n-do.yohn.io/webhook/bcr'

    console.log('dat', data)

    const mode = 'no-cors'
    let hookData = {
      route: 'sent-to-email',
      email: data.emailModal,
      /*options: data.options,*/
    }

    const person = {
      firstName: editableData.firstName,
      lastName: editableData.lastName,
      email: editableData.email,
      phone: editableData.phone,
      address: editableData.address,
      company: editableData.company,
      title: editableData.title,
      website: editableData.website,
      note: note,
    }

    const text = [
      'BEGIN:VCARD',
      'VERSION:3.0',
      `N:${editableData.lastName};${editableData.firstName}`,
      `FN:${editableData.firstName} ${editableData.lastName}`,
    ]

    if (editableData.email) {
      text.push(`EMAIL;TYPE=INTERNET:${editableData.email}`)
    }

    if (editableData.phone) {
      text.push(`TEL;CELL:${editableData.phone}`)
    }

    if (editableData.address) {
      text.push(`ADR:;;${editableData.address}`)
    }

    if (editableData.company) {
      text.push(`ORG:${editableData.company}`)
    }

    if (editableData.title) {
      text.push(`ORG:${editableData.title}`)
    }

    if (editableData.website) {
      text.push(`URL:${editableData.website}`)
    }

    if (note) {
      text.push(`NOTE:${note}`)
    }

    text.push('END:VCARD')

    const bcData = {
      person: person,
      vcard: text.join('\r\n'),
    }

    hookData.bcData = bcData

    setModalLoading(true)
    const r = await callHook({ url, params: hookData, mode })
    console.log('callHook r: ', r)
    setModalLoading(false)
    if (r && r.success === true) {
      setError(false)
      setShowEmailModalSuccess(true)
    } else {
      setError(true)
      setShowEmailModal(false)
    }

    //piwik
    _paq.push([
      'trackEvent',
      'Business Card Reader',
      'Email sent',
      piwikVisitorId,
    ])

    dataLayer.push({
      event: 'trackEvent',
      eventCategory: 'Business Card Reader',
      eventAction: 'Email sent',
    })
  }

  const downloadVCF = async () => {
    let text = [
      'BEGIN:VCARD',
      'VERSION:3.0',
      `N:${editableData.lastName};${editableData.firstName}`,
      `FN:${editableData.firstName} ${editableData.lastName}`,
    ]

    if (editableData.email) {
      text.push(`EMAIL;TYPE=INTERNET:${editableData.email}`)
    }

    if (editableData.phone) {
      text.push(`TEL;CELL:${editableData.phone}`)
    }

    if (editableData.address) {
      text.push(`ADR:;;${editableData.address}`)
    }

    if (editableData.company) {
      text.push(`ORG:${editableData.company}`)
    }

    if (editableData.title) {
      text.push(`ORG:${editableData.title}`)
    }

    if (editableData.website) {
      text.push(`URL:${editableData.website}`)
    }

    if (note) {
      text.push(`NOTE:${note}`)
    }

    text.push('END:VCARD')

    text = text.join('\r\n')

    const url = URL.createObjectURL(
      new Blob([text], { type: 'text/x-vcard;charset=utf-8' }),
    )

    const link = document.createElement('a')
    link.href = url
    link.download = `business-card.vcf`
    document.body.appendChild(link)

    link.click()

    document.body.removeChild(link)

    URL.revokeObjectURL(url)

    //piwik
    _paq.push([
      'trackEvent',
      'Business Card Reader',
      'VCF downloaded',
      piwikVisitorId,
    ])
  }

  const copyText = async () => {
    const text = `First name: ${editableData.firstName}
Last name: ${editableData.lastName}
Company: ${editableData.company}
Title: ${editableData.title}
Email: ${editableData.email}
Phone: ${editableData.phone}
Website: ${editableData.website}
Address: ${editableData.address}
Note: ${note}`

    navigator.clipboard.writeText(text)

    //piwik
    _paq.push([
      'trackEvent',
      'Business Card Reader',
      'Text copied',
      piwikVisitorId,
    ])
  }

  const crmAccessRequest = async (data) => {
    const url = 'https://n8n-do.yohn.io/webhook/bcr'

    const mode = 'no-cors'
    let hookData = {
      route: 'request-access-to-crm',
      data: data,
      crm: selectedCRM.title,
    }

    setLoading(true)
    scrollToElement('loading')
    const r = await callHook({ url, params: hookData, mode })
    console.log('callHook r: ', r)
    if (r.status === 200) {
      setError(false)
    } else {
      setError(true)
    }
    setShowFinalState(true)
    setLoading(false)

    //piwik
    _paq.push([
      'trackEvent',
      'Business Card Reader',
      'CRM form submitted',
      piwikVisitorId,
    ])
  }

  const icons = {
    phone: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="currentColor"
        class="bi bi-telephone"
        viewBox="0 0 16 16"
      >
        <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z" />
      </svg>
    ),
    email: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="currentColor"
        class="bi bi-envelope-at"
        viewBox="0 0 16 16"
      >
        <path d="M2 2a2 2 0 0 0-2 2v8.01A2 2 0 0 0 2 14h5.5a.5.5 0 0 0 0-1H2a1 1 0 0 1-.966-.741l5.64-3.471L8 9.583l7-4.2V8.5a.5.5 0 0 0 1 0V4a2 2 0 0 0-2-2H2Zm3.708 6.208L1 11.105V5.383l4.708 2.825ZM1 4.217V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v.217l-7 4.2-7-4.2Z" />
        <path d="M14.247 14.269c1.01 0 1.587-.857 1.587-2.025v-.21C15.834 10.43 14.64 9 12.52 9h-.035C10.42 9 9 10.36 9 12.432v.214C9 14.82 10.438 16 12.358 16h.044c.594 0 1.018-.074 1.237-.175v-.73c-.245.11-.673.18-1.18.18h-.044c-1.334 0-2.571-.788-2.571-2.655v-.157c0-1.657 1.058-2.724 2.64-2.724h.04c1.535 0 2.484 1.05 2.484 2.326v.118c0 .975-.324 1.39-.639 1.39-.232 0-.41-.148-.41-.42v-2.19h-.906v.569h-.03c-.084-.298-.368-.63-.954-.63-.778 0-1.259.555-1.259 1.4v.528c0 .892.49 1.434 1.26 1.434.471 0 .896-.227 1.014-.643h.043c.118.42.617.648 1.12.648Zm-2.453-1.588v-.227c0-.546.227-.791.573-.791.297 0 .572.192.572.708v.367c0 .573-.253.744-.564.744-.354 0-.581-.215-.581-.8Z" />
      </svg>
    ),
    company: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="currentColor"
        class="bi bi-building"
        viewBox="0 0 16 16"
      >
        <path d="M4 2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1ZM4 5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1ZM7.5 5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1ZM4.5 8a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Z" />
        <path d="M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V1Zm11 0H3v14h3v-2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V15h3V1Z" />
      </svg>
    ),
    address: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="currentColor"
        class="bi bi-house"
        viewBox="0 0 16 16"
      >
        <path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L2 8.207V13.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V8.207l.646.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5ZM13 7.207V13.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V7.207l5-5 5 5Z" />
      </svg>
    ),
    website: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="currentColor"
        class="bi bi-link-45deg"
        viewBox="0 0 16 16"
      >
        <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1.002 1.002 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4.018 4.018 0 0 1-.128-1.287z" />
        <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243L6.586 4.672z" />
      </svg>
    ),
    upload: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="feather feather-upload"
      >
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
        <polyline points="17 8 12 3 7 8"></polyline>
        <line x1="12" y1="3" x2="12" y2="15"></line>
      </svg>
    ),
    img: (
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.8 8.3C4.8 6.64315 6.14315 5.3 7.8 5.3C9.45685 5.3 10.8 6.64315 10.8 8.3C10.8 9.95685 9.45685 11.3 7.8 11.3C6.14315 11.3 4.8 9.95685 4.8 8.3ZM7.8 7.7C7.46863 7.7 7.2 7.96863 7.2 8.3C7.2 8.63137 7.46863 8.9 7.8 8.9C8.13137 8.9 8.4 8.63137 8.4 8.3C8.4 7.96863 8.13137 7.7 7.8 7.7Z"
          fill="#18C884"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 4.1C0 2.11177 1.61177 0.5 3.6 0.5H20.4C22.3882 0.5 24 2.11177 24 4.1V20.9C24 22.8882 22.3882 24.5 20.4 24.5H3.6C1.61177 24.5 0 22.8882 0 20.9V4.1ZM3.6 2.9C2.93726 2.9 2.4 3.43726 2.4 4.1V20.9C2.4 21.4146 2.72391 21.8535 3.17897 22.0241L15.9516 9.25147C16.4202 8.78284 17.18 8.78284 17.6486 9.25147L21.6 13.2029V4.1C21.6 3.43726 21.0627 2.9 20.4 2.9H3.6ZM21.6 16.597L16.8001 11.7971L6.49715 22.1H20.4C21.0627 22.1 21.6 21.5627 21.6 20.9V16.597Z"
          fill="#18C884"
        />
      </svg>
    ),
    cross: (
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.7489 1.46323C12.0837 1.1285 12.0837 0.585786 11.7489 0.251051C11.4142 -0.0836838 10.8715 -0.0836838 10.5368 0.251051L6 4.78782L1.46323 0.251051C1.1285 -0.0836838 0.585786 -0.0836838 0.251051 0.251051C-0.0836838 0.585786 -0.0836838 1.1285 0.251051 1.46323L4.78782 6L0.251051 10.5368C-0.0836838 10.8715 -0.0836838 11.4142 0.251051 11.7489C0.585786 12.0837 1.1285 12.0837 1.46323 11.7489L6 7.21218L10.5368 11.7489C10.8715 12.0837 11.4142 12.0837 11.7489 11.7489C12.0837 11.4142 12.0837 10.8715 11.7489 10.5368L7.21218 6L11.7489 1.46323Z"
          fill="#202830"
        />
      </svg>
    ),
    right: (
      <svg
        width="8"
        height="12"
        viewBox="0 0 8 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.99372 0.251051C1.65201 -0.0836838 1.09799 -0.0836838 0.756282 0.251051C0.414573 0.585786 0.414573 1.1285 0.756282 1.46323L5.38756 6L0.756282 10.5368C0.414573 10.8715 0.414573 11.4142 0.756282 11.7489C1.09799 12.0837 1.65201 12.0837 1.99372 11.7489L7.24372 6.60609C7.58543 6.27136 7.58543 5.72864 7.24372 5.39391L1.99372 0.251051Z"
          fill="#2D3648"
        />
      </svg>
    ),
    email: (
      <svg
        width="16"
        height="14"
        viewBox="0 0 16 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.84341e-05 2.65414C-1.95112e-05 2.66127 -3.14003e-05 2.66839 6.24258e-05 2.67551V11.3333C6.24258e-05 12.5266 0.980211 13.5 2.18186 13.5H13.8181C15.0198 13.5 15.9999 12.5266 15.9999 11.3333V2.6756C16 2.66841 16 2.66122 15.9999 2.65404C15.993 1.46649 15.0155 0.5 13.8181 0.5H2.18186C0.984418 0.5 0.00692812 1.46655 9.84341e-05 2.65414ZM1.53211 2.34452C1.65238 2.10833 1.89971 1.94444 2.18186 1.94444H13.8181C14.1003 1.94444 14.3476 2.10833 14.4679 2.34452L8 6.84064L1.53211 2.34452ZM14.5454 4.05381V11.3333C14.5454 11.7289 14.2165 12.0556 13.8181 12.0556H2.18186C1.78353 12.0556 1.4546 11.7289 1.4546 11.3333V4.05381L7.58294 8.31389C7.83335 8.48796 8.16665 8.48796 8.41706 8.31389L14.5454 4.05381Z"
          fill="currentColor"
        />
      </svg>
    ),
    plusSquare: (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 4C8.44183 4 8.8 4.35817 8.8 4.8V7.2H11.2C11.6418 7.2 12 7.55817 12 8C12 8.44183 11.6418 8.8 11.2 8.8H8.8V11.2C8.8 11.6418 8.44183 12 8 12C7.55817 12 7.2 11.6418 7.2 11.2V8.8H4.8C4.35817 8.8 4 8.44183 4 8C4 7.55817 4.35817 7.2 4.8 7.2H7.2V4.8C7.2 4.35817 7.55817 4 8 4Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 2.4C0 1.07452 1.07452 0 2.4 0H13.6C14.9255 0 16 1.07452 16 2.4V13.6C16 14.9255 14.9255 16 13.6 16H2.4C1.07452 16 0 14.9255 0 13.6V2.4ZM2.4 1.6C1.95817 1.6 1.6 1.95817 1.6 2.4V13.6C1.6 14.0418 1.95817 14.4 2.4 14.4H13.6C14.0418 14.4 14.4 14.0418 14.4 13.6V2.4C14.4 1.95817 14.0418 1.6 13.6 1.6H2.4Z"
          fill="currentColor"
        />
      </svg>
    ),
    download: (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.8 0.8C8.8 0.358172 8.44183 0 8 0C7.55817 0 7.2 0.358172 7.2 0.8V8.46863L4.56569 5.83431C4.25327 5.5219 3.74673 5.5219 3.43431 5.83431C3.1219 6.14673 3.1219 6.65327 3.43431 6.96569L7.43431 10.9657C7.74673 11.2781 8.25327 11.2781 8.56569 10.9657L12.5657 6.96569C12.8781 6.65327 12.8781 6.14673 12.5657 5.83431C12.2533 5.5219 11.7467 5.5219 11.4343 5.83431L8.8 8.46863V0.8Z"
          fill="currentColor"
        />
        <path
          d="M0.8 9.6C1.24183 9.6 1.6 9.95817 1.6 10.4V13.6C1.6 13.8122 1.68429 14.0157 1.83431 14.1657C1.98434 14.3157 2.18783 14.4 2.4 14.4H13.6C13.8122 14.4 14.0157 14.3157 14.1657 14.1657C14.3157 14.0157 14.4 13.8122 14.4 13.6V10.4C14.4 9.95817 14.7582 9.6 15.2 9.6C15.6418 9.6 16 9.95817 16 10.4V13.6C16 14.2365 15.7471 14.847 15.2971 15.2971C14.847 15.7471 14.2365 16 13.6 16H2.4C1.76348 16 1.15303 15.7471 0.702944 15.2971C0.252856 14.847 0 14.2365 0 13.6V10.4C0 9.95817 0.358172 9.6 0.8 9.6Z"
          fill="currentColor"
        />
      </svg>
    ),
    copy: (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.66756 1.66756C1.80395 1.53117 1.98893 1.45455 2.18182 1.45455H8.72727C8.92016 1.45455 9.10514 1.53117 9.24153 1.66756C9.37792 1.80395 9.45455 1.98893 9.45455 2.18182V2.90909C9.45455 3.31075 9.78016 3.63636 10.1818 3.63636C10.5835 3.63636 10.9091 3.31075 10.9091 2.90909V2.18182C10.9091 1.60316 10.6792 1.04821 10.2701 0.63904C9.86088 0.229869 9.30593 0 8.72727 0H2.18182C1.60316 0 1.04821 0.229869 0.63904 0.63904C0.229869 1.04821 0 1.60316 0 2.18182V8.72727C0 9.30593 0.229869 9.86088 0.63904 10.2701C1.04821 10.6792 1.60316 10.9091 2.18182 10.9091H2.90909C3.31075 10.9091 3.63636 10.5835 3.63636 10.1818C3.63636 9.78016 3.31075 9.45455 2.90909 9.45455H2.18182C1.98893 9.45455 1.80395 9.37792 1.66756 9.24153C1.53117 9.10514 1.45455 8.92016 1.45455 8.72727V2.18182C1.45455 1.98893 1.53117 1.80395 1.66756 1.66756Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.27273 5.09091C6.06774 5.09091 5.09091 6.06774 5.09091 7.27273V13.8182C5.09091 15.0232 6.06774 16 7.27273 16H13.8182C15.0232 16 16 15.0232 16 13.8182V7.27273C16 6.06774 15.0232 5.09091 13.8182 5.09091H7.27273ZM6.54545 7.27273C6.54545 6.87107 6.87107 6.54545 7.27273 6.54545H13.8182C14.2198 6.54545 14.5455 6.87107 14.5455 7.27273V13.8182C14.5455 14.2198 14.2198 14.5455 13.8182 14.5455H7.27273C6.87107 14.5455 6.54545 14.2198 6.54545 13.8182V7.27273Z"
          fill="currentColor"
        />
      </svg>
    ),
  }

  const displayNames = {
    name: 'Name',
    firstName: 'First name',
    lastName: 'Last name',
    email: 'Email',
    phone: 'Phone',
    address: 'Address',
    company: 'Company',
    website: 'Website',
    title: 'Title',
  }

  const excludedKeys = ['firstName', 'lastName']

  const handleInputChange = (key, value) => {
    setEditableData((prevData) => ({
      ...prevData,
      [key]: value,
    }))
  }

  const processFiles = (files) => {
    const newFiles = [];
    let error = '';
  
    const currentFiles = selectedFiles.length;

    setImgErrorMessage('');
  
    if (currentFiles + files.length > 2) {
      error = 'You can only upload up to 2 files.';
      setImgErrorMessage(error);
      return;
    }
  
    const hasInvalidFile = files.some((file) => {
      const fileName = file.name;
      const fileExtension = fileName.split('.').pop().toLowerCase();
  
      if (!acceptedFileTypes.includes(fileExtension)) {
        error = `File type not accepted: ${fileName}`;
        setImgErrorMessage(error);
        return true;
      }
  
      newFiles.push(file);
      return false;
    });
  
    if (hasInvalidFile) {
      return;
    }
  
    setSelectedFiles((prevFiles) => [...prevFiles, ...newFiles]);
  
    setTimeout(() => {
      scrollToElement('files');
    }, 0);
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    processFiles(files);
  };

  const handleFileRemove = (index) => {
    setSelectedFiles((prevFiles) => {
      const updatedFiles = prevFiles.filter((_, i) => i !== index)
      return updatedFiles
    })
  }

  const handleClearFiles = () => {
    setSelectedFiles([])
    if (fileInputRef.current) {
      fileInputRef.current.value = ''
    }
  }

  const handleDragOver = (e) => {
    e.preventDefault()
    e.stopPropagation()
    e.dataTransfer.dropEffect = 'copy'
  }

  const handleDragLeave = (e) => {
    e.preventDefault()
    e.stopPropagation()
  }

  const handleDrop = (e) => {
    e.preventDefault()
    e.stopPropagation()

    const files = Array.from(e.dataTransfer.files)
    processFiles(files)
  }

  const resetStates = () => {
    setLoading(false)
    setModalLoading(false)

    setShowEditor(false)
    setShowCRMList(false)
    setShowCRMForm(false)

    setSelectedFiles([])

    setSelectedCRM(null)
    setShowFinalState(null)

    setError(false)
    //setErrorMessage()
  }

  const renderContent = () => {
    //card form
    const cardForm = () => {
      return (
        <div className="bg-light border rounded-4 p-3">
          <form className="text-center col">
            <div className={`row ${showCRMList && 'opacity-50'}`}>
              {Object.entries(editableData).map(([key, value]) =>
                key !== 'note' && excludedKeys.includes(key) && value ? (
                  <div key={key} className={`col-12 col-lg-6`}>
                    <label className="w-100 text-start mb-2">
                      <span className="h6 opacity-75">{`${
                        displayNames[key] || key
                      }`}</span>
                      <input
                        type="text"
                        value={value || ''}
                        onChange={(e) => handleInputChange(key, e.target.value)}
                        className={`form-control mt-1`}
                        readOnly={showCRMList}
                      />
                    </label>
                  </div>
                ) : (
                  <div key={key} className={`col-12`}>
                    <label className="w-100 text-start mb-2">
                      <span className="h6 opacity-75">{`${
                        displayNames[key] || key
                      }: `}</span>
                      <input
                        type="text"
                        value={value || ''}
                        onChange={(e) => handleInputChange(key, e.target.value)}
                        className={`form-control mt-1`}
                        readOnly={showCRMList}
                      />
                    </label>
                  </div>
                ),
              )}
              <div className={`col-12`}>
                <label className="w-100 text-start">
                  <span className="h6 opacity-75">{`Note`}</span>
                  <textarea
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                    className={`form-control mt-1`}
                    rows="3"
                    readOnly={showCRMList}
                  />
                </label>
              </div>
            </div>
          </form>
        </div>
      )
    }

    //Loading
    if (isLoading) {
      return (
        <div id="loading" className="mt-5">
          <div className="text-center">
            <div className="loader mx-auto"></div>
          </div>
        </div>
      )
    }

    //Final state
    if (showFinalState) {
      return (
        <div className="mt-4">
          <h4 className="col-12 col-lg-10 mx-auto text-center">
            Your request has been received, we will reach out to you soon.
          </h4>
          <div className="row flex-wrap justify-content-center gap-3 mt-4">
            <button
              type="submit"
              className={'col-auto btn btn-sm btn-light text-uppercase'}
              onClick={() => setShowFinalState(false)}
            >
              Back to the current card
            </button>
            <button
              type="submit"
              className={'col-auto btn btn-sm btn-primary text-uppercase'}
              onClick={() => resetStates()}
            >
              Scan another card
            </button>
          </div>
        </div>
      )
    }

    //CRM form
    if (showCRMForm) {
      return (
        <div className="mt-4">
          <div className="row row-gap-4 justify-content-center">
            <div className="col-12 col-lg-7">{cardForm()}</div>
            <div className="col-12 col-lg-5">
              <h4 className="text-center">
                Add your contact info to connect your CRM.
              </h4>
              <form
                onSubmit={crmForm.handleSubmit(crmAccessRequest)}
                className="text-center col"
              >
                <div className={`rounded-4 border p-3`}>
                  {selectedCRM.img ? (
                    <img
                      src={selectedCRM.img}
                      width="120"
                      height="60"
                      style={{ objectFit: 'contain' }}
                    />
                  ) : (
                    <h5 className="mb-3">{selectedCRM.title}</h5>
                  )}
                  <label className="w-100 text-start">
                    <span className="h6 opacity-75">{`Name`}</span>
                    <input
                      className={'form-control mt-1'}
                      {...crmForm.register('name', { required: false })}
                    />
                  </label>
                  <label className="w-100 text-start mt-2">
                    <span className="h6 opacity-75">{`Phone`}</span>
                    <input
                      className={'form-control mt-1'}
                      {...crmForm.register('phone', { required: false })}
                    />
                  </label>
                  <label className="w-100 text-start mt-2">
                    <span className="h6 opacity-75">{`Email`}</span>
                    <input
                      className={'form-control mt-1'}
                      {...crmForm.register('email', {
                        required: true,
                        validate: (input) => validator.validate(input),
                      })}
                    />
                  </label>
                </div>
                <div className="d-flex justify-content-between mt-3 ">
                  <button
                    className={'btn btn-sm btn-light text-uppercase'}
                    onClick={() => setShowCRMForm(false)}
                  >
                    GO Back
                  </button>
                  <button
                    type="submit"
                    className={'btn btn-sm btn-primary text-uppercase'}
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )
    }

    //CRM list
    if (showCRMList) {
      return (
        <div className="mt-4">
          <div className="row row-gap-4 justify-content-center">
            <div className="col-12 col-lg-7">{cardForm()}</div>
            <div className="col-12 col-lg-5">
              <div className="d-flex flex-column gap-3">
                <h4 className="text-center">
                  Please select your CRM platform.
                </h4>
                <div
                  className="rounded-4 border d-flex align-items-center"
                  style={{ padding: '12px', cursor: 'pointer' }}
                  onClick={() => {
                    setSelectedCRM({
                      title: 'HubSpot',
                      img: `https://colibri-live.cdn.prismic.io/colibri-live/Z_ZiC3dAxsiBwe29_HubSpot_Logo.svg`,
                    })
                    setShowCRMForm(true)
                  }}
                >
                  <div className="d-flex flex-fill justify-content-center align-items-center">
                    <img
                      src="https://colibri-live.cdn.prismic.io/colibri-live/Z_ZiC3dAxsiBwe29_HubSpot_Logo.svg"
                      alt="HubSpot logo"
                      width="120"
                      height="60"
                      style={{ objectFit: 'contain' }}
                    />
                  </div>
                  <div
                    className="rounded-circle border d-flex justify-content-center align-items-center"
                    style={{
                      width: '40px',
                      height: '40px',
                    }}
                  >
                    {icons.right}
                  </div>
                </div>
                <div
                  className="rounded-4 border d-flex align-items-center"
                  style={{ padding: '12px', cursor: 'pointer' }}
                  onClick={() => {
                    setSelectedCRM({
                      title: 'Salesforce',
                      img: 'https://colibri-live.cdn.prismic.io/colibri-live/Z_5h3uvxEdbNPEkE_Salesforce.com_logo.svg',
                    })
                    setShowCRMForm(true)
                  }}
                >
                  <div className="d-flex flex-fill justify-content-center align-items-center">
                    <img
                      src="https://colibri-live.cdn.prismic.io/colibri-live/Z_5h3uvxEdbNPEkE_Salesforce.com_logo.svg"
                      alt="Salesforce logo"
                      width="120"
                      height="60"
                      style={{ objectFit: 'contain' }}
                    />
                  </div>
                  <div
                    className="rounded-circle border d-flex justify-content-center align-items-center"
                    style={{
                      width: '40px',
                      height: '40px',
                    }}
                  >
                    {icons.right}
                  </div>
                </div>
                <div
                  className="rounded-4 border d-flex align-items-center"
                  style={{ padding: '12px', cursor: 'pointer' }}
                  onClick={() => {
                    setSelectedCRM({
                      title: 'Other',
                    })
                    setShowCRMForm(true)
                  }}
                >
                  <div
                    className="d-flex flex-fill justify-content-center align-items-center"
                    style={{ height: '60px' }}
                  >
                    <h5 className="mb-0">Other</h5>
                  </div>
                  <div
                    className="rounded-circle border d-flex justify-content-center align-items-center"
                    style={{
                      width: '40px',
                      height: '40px',
                    }}
                  >
                    {icons.right}
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-between mt-3 ">
                <button
                  className={'btn btn-sm btn-light text-uppercase'}
                  onClick={() => setShowCRMList(false)}
                >
                  GO Back
                </button>
              </div>
            </div>
          </div>
        </div>
      )
    }

    //editor
    if (showEditor) {
      return (
        <>
          <h4 className="col-12 col-lg-10 mx-auto text-center mt-4 p-0 p-lg-2">
            Details extracted. Review, edit, or add notes - then choose your
            next step.
          </h4>
          <div className="mt-4">
            {parsedData ? (
              <div className="row row-gap-4 justify-content-center">
                <div className="col-12 col-lg-7">{cardForm()}</div>
                <div
                  className="col-12 col-lg-auto d-flex flex-column gap-4"
                  style={{ width: 'fit-content' }}
                >
                  <button
                    type="button"
                    className="btn btn-sm btn-primary text-uppercase w-100 d-flex gap-2 justify-content-between align-items-center"
                    onClick={() => setShowEmailModal(true)}
                  >
                    {'Send it to my email'}
                    {icons.email}
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-primary text-uppercase w-100 d-flex gap-2 justify-content-between align-items-center"
                    onClick={() => setShowCRMList(true)}
                  >
                    {'Add to my CRM'}
                    {icons.plusSquare}
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-light text-uppercase w-100 d-flex gap-2 justify-content-between align-items-center"
                    onClick={() => downloadVCF()}
                  >
                    {'Download contact'}
                    {icons.download}
                  </button>
                  <OverlayTrigger
                    trigger="click"
                    placement="top"
                    rootClose
                    overlay={
                      <Popover>
                        <Popover.Body className="p-2">Copied</Popover.Body>
                      </Popover>
                    }
                  >
                    <button
                      type="button"
                      className="btn btn-sm btn-light text-uppercase w-100 d-flex gap-2 justify-content-between align-items-center"
                      onClick={() => copyText()}
                    >
                      {'Copy contact info'}
                      {icons.copy}
                    </button>
                  </OverlayTrigger>
                </div>
              </div>
            ) : (
              <div className="col-12 col-lg-7 mx-auto text-center">
                <p>
                  {
                    "Unfortunately, we couldn't scan your business card. Please upload a new photo, ensuring that your email address, first name, and last name are clearly visible."
                  }
                </p>
                <button
                  type="button"
                  className="btn btn-sm btn-primary text-uppercase"
                  style={{ width: 'fit-content' }}
                  onClick={() => setShowEditor(false)}
                >
                  {'Try again'}
                </button>
              </div>
            )}
            <Modal
              show={showEmailModal}
              onHide={() => {
                setShowEmailModal(false)
                setShowEmailModalSuccess(false)
                setModalLoading(false)
              }}
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title>Send it to my email</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {isModalLoading && (
                  <div className="text-center py-5">
                    <div className="loader mx-auto"></div>
                  </div>
                )}
                {showEmailModalSuccess && (
                  <h6 className="text-center py-5">
                    {'Done! Check your email for the scanned card.'}
                  </h6>
                )}
                {!isModalLoading && !showEmailModalSuccess && (
                  <form
                    onSubmit={modalForm.handleSubmit(sentToEmail)}
                    className="text-center"
                  >
                    <div>
                      <label className="w-100 text-start mb-2">
                        <span className="h6 opacity-75">{`Enter your email`}</span>
                        <input
                          id="email"
                          className="form-control mt-1"
                          {...modalForm.register('emailModal', {
                            required: true,
                            validate: (input) => validator.validate(input),
                          })}
                        />
                      </label>
                    </div>

                    {/*<div className={'form-check text-start mb-0'}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="textCheckbox"
                    value="text"
                    {...register('options', {
                      validate: (value) =>
                        value?.includes('text') ||
                        value?.includes('vcf') ||
                        'Please select at least one option',
                    })}
                  />
                  <label className="form-check-label" for="textCheckbox">
                    <span className="fs-0875">Send me text</span>
                  </label>
                </div>
                <div className={'form-check text-start mt-2 mb-0'}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="vcfCheckbox"
                    value="vcf"
                    {...register('options', {
                      validate: (value) =>
                        value?.includes('text') ||
                        value?.includes('vcf') ||
                        'Please select at least one option',
                    })}
                  />
                  <label className="form-check-label" for="vcfCheckbox">
                    <span className="fs-0875">Send me .vcf file</span>
                  </label>
                </div>*/}
                    <button
                      type="submit"
                      className="btn btn-sm btn-primary text-uppercase mt-3"
                      style={{ width: 'fit-content' }}
                    >
                      {'Send it to my email'}
                    </button>
                  </form>
                )}
              </Modal.Body>
            </Modal>
          </div>
        </>
      )
    }

    //default
    return (
      <>
        <h4 className="col-12 col-lg-10 mx-auto text-center mt-4 p-0 p-lg-2">
          Just upload a photo of a business card, and Yohn.io will turn it into
          editable text or a .vcf file that you can add to your contacts or CRM.
        </h4>
        <div className="mt-4">
          <style>
            {`.custom-file-upload {
            background-color:#ffffff;
            border: 1px solid #ccc;
            display: inline-block;
            padding: 12px 24px;
            cursor: pointer;
          }
          .custom-file-upload:hover {
            background-color:#ffffff;
            border: 1px solid #ccc;
          }`}
          </style>
          <form
            className="text-center row g-4"
            onSubmit={imageForm.handleSubmit(submitImage)}
          >
            <div
              className={`${
                selectedFiles.length > 0 ? 'col-12 col-lg-6' : 'col-12'
              }`}
            >
              <label
                for="img-upload"
                className={`w-100 rounded-4 bg-light p-4 d-flex flex-column justify-content-center align-items-center`}
                style={{
                  minHeight: '280px',
                  border: '1px solid #dee2e6',
                  borderStyle: 'dashed',
                  cursor: 'pointer',
                }}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
              >
                <div
                  className="bg-white border rounded-3 d-flex justify-content-center align-items-center"
                  style={{
                    width: '60px',
                    height: '60px',
                  }}
                >
                  {icons.img}
                </div>
                  <h5 className="mt-3">
                    {isMobile
                      ? 'Click to take a photo or upload file'
                      : 'Drag & drop or upload files here'}
                  </h5>
                  <p className="fs-0875 text-center">
                    Max 2 photos per card (front & back only).
                    <br /> Supported formats: JPG and PNG
                  </p>
                  {imgErrorMessage && (
                    <div className="alert alert-light">
                      {imgErrorMessage}
                    </div>
                  )}
                <label
                  for="img-upload"
                  class={`btn text-uppercase custom-file-upload ${
                    selectedFiles.length >= 2 && 'opacity-50'
                  }`}
                >
                  {isMobile ? 'Add photo' : 'BROWSE'} {icons.upload}
                </label>
                <input
                  id="img-upload"
                  className="d-none"
                  type="file"
                  multiple
                  onChange={handleFileChange}
                  disabled={selectedFiles.length >= 2}
                  ref={fileInputRef}
                />
              </label>
            </div>
            {selectedFiles.length > 0 && (
              <div
                id="files"
                className="col-12 col-lg-6 d-flex flex-column justify-content-between"
              >
                <div className="d-flex flex-column gap-2">
                  {selectedFiles.map((file, index) => (
                    <div
                      key={index}
                      className="rounded-4 border d-flex justify-content-between align-items-center"
                      style={{ padding: '12px' }}
                    >
                      <div className="d-flex align-items-center">
                        <div
                          className="rounded-3 d-flex justify-content-center align-items-center"
                          style={{
                            width: '60px',
                            height: '60px',
                            backgroundColor: '#18C88432',
                          }}
                        >
                          {icons.img}
                        </div>
                        <span className="h6 ms-3 mb-0">{file.name}</span>
                      </div>
                      <div
                        className="rounded-circle border d-flex justify-content-center align-items-center"
                        style={{
                          width: '40px',
                          height: '40px',
                          cursor: 'pointer',
                        }}
                        onClick={() => handleFileRemove(index)}
                      >
                        {icons.cross}
                      </div>
                    </div>
                  ))}
                </div>
                <div>
                  <div className="d-flex">
                    <div className={'form-check text-start mt-4 mb-0'}>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="termCheckbox"
                        required
                      />
                      <label className="form-check-label" for="termCheckbox">
                        <span className="fs-0875">
                          I agree to the <a href="/terms/">Terms of Service</a>,{' '}
                          <a href="/privacy-policy/">Privacy Policy</a> and Use
                          of Cookies.
                        </span>
                      </label>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between mt-3">
                    <button
                      className={'btn btn-sm btn-light text-uppercase'}
                      onClick={handleClearFiles}
                    >
                      Clear all
                    </button>
                    <button
                      type="submit"
                      className={'btn btn-sm btn-primary text-uppercase'}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            )}
          </form>
        </div>
      </>
    )
  }

  return (
    <>
      <div className="py-6">
        <div className="container">
          {isFirst ? (
            <h1 className="h2 text-center">{title}</h1>
          ) : (
            <h2 className="text-center">{title}</h2>
          )}
          {isError ? (
            <div className="text-center mt-4">
              <h4>An error has occurred</h4>
              <p>
                Sorry, the service is currently unavailable. Please try again
                later.
              </p>
              <button
                type="button"
                className="btn btn-sm btn-primary text-uppercase"
                style={{ width: 'fit-content' }}
                onClick={() => resetStates()}
              >
                {'Try again'}
              </button>
            </div>
          ) : (
            renderContent()
          )}
        </div>
      </div>
      <div className="bg-light text-center d-flex justify-content-center align-items-center py-4">
        <p className="h6 mb-0 text-secondary lh-base">No app&nbsp;&nbsp;·&nbsp;&nbsp;No signup needed&nbsp;&nbsp;·&nbsp;&nbsp;99%+ Recognition Accuracy&nbsp;&nbsp;·&nbsp;&nbsp;GDPR-Compliant&nbsp;&nbsp;·&nbsp;&nbsp;100% Private</p>
      </div>
      <Test piwikVisitorId={piwikVisitorId} />
    </>
  )
}

export const query = graphql`
  fragment PageDataBodyBusinessCardReader on PrismicPageDataBodyBusinessCardReader {
    primary {
      title
    }
  }
`
